import { Button, Grid, Modal, makeStyles } from '@material-ui/core';
import { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { fetchTagsByUser } from '../../../../redux/actions/flag-actions';
import { setTimeProgress } from '../../../../redux/actions/player-actions';
import { firebase } from '../../../../firebase';
import { ReactComponent as IconMyFlags } from '../../../../images/icon-my-flags-highlight.svg';
import highlightDownActiveButton from '../../../../images/icon-thumbs-down-active.png';
import highlightDownButton from '../../../../images/icon-thumbs-down.png';
import highlightUpActiveButton from '../../../../images/icon-thumbs-up-active.png';
import highlightUpButton from '../../../../images/icon-thumbs-up.png';
import '../../../player/styles/capture-flags.css';
import ProgressBar from '../../../../components/ProgressBar';
import CaptureWithComment from '../../../../components/highlight/CaptureWithComment';
import CaptureWithTag from '../../../../components/highlight/CaptureWithTag';
import { AccessTime, Check, Clear } from '@material-ui/icons';
import { isMobile } from 'react-device-detect';

const useStyles = makeStyles((theme) => ({
  '@global': {
    '*::-webkit-scrollbar': {
      width: '5px'
    },
    '*::-webkit-scrollbar-track': {
      backgroundColor: 'rgba(255,255,255,0.15)'
    },
    '*::-webkit-scrollbar-thumb': {
      backgroundColor: 'rgba(255,255,255)',
      borderRadius: '8px'
    }
  },
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#ededef'
  },
  paper: {
    width: 500,
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3)
  }
}));

const HighlightFlagWithJudgement = ({
  open,
  onClose,
  fetchTags,
  saveFlag,
  tags,
  inputTagName,
  isMobileWidth,
  setInputTagName,
  inputCommentName,
  setInputCommentName,
  radioButtonValue,
  setRadioButtonValue,
  setTimeProgress_disp,
  isPersonalPodcast
}) => {
  const classes = useStyles();
  const [activeStep, setActiveStep] = useState(0);
  const [countdown, setCountdown] = useState(5);
  const [tagError, setTagError] = useState({
    hasError: false,
    errorMessage: ''
  });
  const [buttonTitle, setButtonTitle] = useState('Comment / Tag');
  const [up, setUp] = useState(false);
  const [down, setDown] = useState(false);
  const position = isMobileWidth ? { top: '100px', left: '24px' } : { top: '40%', left: 'calc(37.5% - 100px)' };


   const judgementIcons = {
      'Agree': <Check style={{ verticalAlign: 'middle', color: 'var(--color-light-green)', fontSize: 20, marginRight: 12 }} />,
      'Concern': <Clear style={{ verticalAlign: 'middle', color: 'var(--color-error-red)', fontSize: 20, marginRight: 12 }} />,
      'Follow up': <AccessTime style={{ verticalAlign: 'middle', color: 'var(--color-warning-yellow)', fontSize: 20, marginRight: 12 }} />
    }

    useEffect(() => {
      let timer;
      if (open) {
        setCountdown(5);
        timer = setInterval(() => {
          setCountdown((prev) => {
            if (prev === 1) {
              clearInterval(timer);
              handleDirectClose();
            }
            return prev - 1;
          });
        }, 1000);
      }
      return () => clearInterval(timer);
    }, [open]);

  const renderModalCloseIcon = () => {
    return (
      <Grid
        item
        xs={12}
        className="capture-flags-modal__header-btn"
        style={{ textAlign: 'right' }}
      >
        <Button onClick={handleClose}>x</Button>
      </Grid>
    );
  };

  const handleClose = () => {
    onClose();
    setActiveStep(0);
    setInputTagName('');
    setInputCommentName('');
    setRadioButtonValue('');
    setUp(false);
    setDown(false);
    setButtonTitle('Comment / Tag');
    setTimeProgress_disp(0);
    setTagError({ hasError: false, errorMessage: '' });
  };

  const handleDirectClose = () => {
    saveFlag();
    handleClose();
  };

  const handleClickJudgement = (tag) => {
    saveFlag(tag, undefined);
    handleClose();
  }

  const handleButtonTagComment = async () => {
    const token = await firebase.auth.currentUser.getIdToken();
    if (token) {
      await fetchTags(token);
    }
    setActiveStep(1);
  };

  const handleTagInputChange = (event) => {
    const { value } = event.target;
    setRadioButtonValue(null);
    setInputTagName(value);
    setTagError({ hasError: false, errorMessage: '' });
  };

  const handleCommentInputChange = (event) => {
    const { value } = event.target;
    setInputCommentName(value);
  };

  const handleRadioChange = (value) => {
    setInputTagName(value);
    setRadioButtonValue(value);
    setTagError({ hasError: false, errorMessage: '' });
  };

  const handleClickUp = () => {
    setUp(!up);
    setDown(false);
    if (up && !down) {
      setButtonTitle('Comment / Tag');
    } else {
      setButtonTitle('Comment');
    }
    setTimeProgress_disp(0);
  };

  const handleClickDown = () => {
    setUp(false);
    setDown(!down);
    if (!up && down) {
      setButtonTitle('Comment / Tag');
    } else {
      setButtonTitle('Comment');
    }
    setTimeProgress_disp(0);
  };

  if (!open) {
    return null;
  }

  return (
    <div className="pdf-judgement-popup" style={{top: position.top, left: position.left}}>
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <div style={{ marginTop: '10px', color: 'var(--color-light-gray)', fontSize: '12px' }}>
          Select a judgement if appropriate... {countdown}
        </div>
        <div className="pdf-judgement-row" >
             <Button
                    className="judgement-btn"
                    onClick={() => handleClickJudgement('Agree')}
                  >
                    <div style={{width: 100, textAlign: 'left'}}>{judgementIcons['Agree']} Agree</div>
                  </Button>
        </div>
        <div className="pdf-judgement-row">
                       <Button
                    className="judgement-btn"
                    onClick={() => handleClickJudgement('Concern')}
                  >
                    <div style={{width: 100, textAlign: 'left'}}>{judgementIcons['Concern']} Concern</div>
                  </Button>
        </div>
        <div>
                       <Button
                    className="judgement-btn"
                    onClick={() => handleClickJudgement('Follow up')}
                  >
                    <div style={{width: 100, textAlign: 'left'}}>{judgementIcons['Follow up']} Follow up</div>
                  </Button>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (store) => {
  return {
    tags: store.flag.tags,
    timeProgress: store.player.timeProgress
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchTags: (token) => {
      dispatch(fetchTagsByUser(token));
    },
    setTimeProgress_disp: (value) => {
      dispatch(setTimeProgress(value));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(HighlightFlagWithJudgement);
